import { render, staticRenderFns } from "./df-form-delete-account.vue?vue&type=template&id=f031e466&"
import script from "./df-form-delete-account.ts?vue&type=script&lang=js&"
export * from "./df-form-delete-account.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports